<template>
  <div class="data-field-image">
    <template v-if="url">
      <div class="image-border-wrap">
        <el-image :src="$contextPath(thumbnail || url)"
                  :preview-src-list="previewList.map(u => $contextPath(u))"
                  :initial-index="previewList.indexOf(url)"
                  fit="cover"
                  class="image-preview">
          <div slot="error"
               class="image-error">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <span v-if="name"
              class="image-name">{{ name }}</span>
        <a class="image-download theme-text-hover"
           :href="$contextPath(url)"
           :download="name || true"
           target="_blank">
          <i class="el-icon-download"></i>
        </a>
      </div>
    </template>
    <template v-else>
      <span class="field-empty">-</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ImageField',
  inject: ['$formPanel'],
  props: {
    name: String,
    url: {
      type: String,
      required: true
    },
    thumbnail: String
  },
  computed: {
    previewList () {
      const urls = this.$formPanel ? this.$formPanel.imageUrls : []
      return urls && urls.length ? urls : [this.url]
    }
  }
}
</script>

<style lang="scss" scoped>
.data-field-image {
  display: flex;
  align-items: center;

  .image-border-wrap {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #F3F5F7;
  }

  .image-preview {
    flex: none;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    cursor: pointer;

    .image-error {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: #fff;
      color: #909399;
      font-size: 20px;
    }
  }

  .image-name {
    flex: 1;
    margin-left: 8px;
    font-size: 13px;
    color: #606266;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .image-download {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    font-size: 16px;
    color: #909399;
    cursor: pointer;
    transition: color 0.2s;
  }

  .field-empty {
    font-size: 13px;
    color: #909399;
  }
}
</style>
